module.exports = __webpack_public_path__ + "static/fonts/FiraSans-Medium.87302ae.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/FiraSans/FiraSans-Medium.ttf
// module id = 1160
// module chunks = 5